import bridge from './bridge';
import env from './env';
import { outLogin } from 'services/login';
import { log } from 'src/utils/slardar';

export const supportLogin = env.isInToutiaoProduct;
export const allNeedLogin = env.isInHotsoon;

let isOutLogin = false;
export function checkAndLogin(loginParams?: Object): Promise<any> {
    return new Promise((resolve, reject) => {
        // 不做强制登录的端
        if (env.isInSuper || process.env.NODE_ENV === 'development') {
            return resolve({ st: 10001 });
        }
        isLogin()
            .then((res) => {
                if (!res) return login(loginParams);
                return resolve({ st: 10001 }); // 本来就已经登录了的情况
            })
            .then(() => {
                return isLogin();
            })
            .then((res: any) => {
                if (res) {
                    if (!env.isIOS) {
                        resolve({ st: 0 });
                    }
                    setTimeout(() => {
                        resolve({ st: 0 });
                    }, 800);
                } else {
                    resolve({ st: -1 });
                }
            })
            .catch((err: any) => {
                reject(err);
            });
    });
}
export function isLogin() {
    return new Promise((resolve, reject) => {
        if (env.appName === 'UNKNOWN' || env.isInWechat) {
            window.ToutiaoJSBridge &&
                window.ToutiaoJSBridge.call('appInfo', {}, (res: any) => {
                    log(
                        {
                            url: window.location.href,
                            ua: window.navigator.userAgent,
                            appInfo: res
                        },
                        { type: 'web login' }
                    );
                });

            return resolve(isOutLogin);
        }
        if (bridge.supports('is_login')) {
            return bridge
                .call('is_login', {}, { timeout: 1000 })
                .then((res: any) => {
                    if (env.isIOS) {
                        resolve(res.is_login);
                    } else {
                        resolve(Number(res.code) === 1);
                    }
                })
                .catch((e) => {
                    reject(e);
                });
        }
        if (bridge.supports('userInfo')) {
            return bridge
                .call('userInfo', {}, { timeout: 1000 })
                .then((res: any) => {
                    resolve(res.code === 1 && res.is_login);
                })
                .catch((e) => {
                    reject(e);
                });
        }
        return Promise.reject(new Error('not supports'));
    });
}

export function login(loginParams?: Object) {
    if (env.appName === 'UNKNOWN' || env.isInWechat) {
        return outLogin().then(() => {
            isOutLogin = true;
        });
    }
    if (env.isInSuper) {
        return new Promise((reslove, reject) => {
            bridge.call('BDSWebApp.login', loginParams).then((res: any) => {
                if (res.ret === 'JSB_FAILED') {
                    reject(new Error('登录失败'));
                } else {
                    reslove();
                }
            });
        });
    }
    if (bridge.supports('login')) {
        return bridge.call('login', loginParams);
    }
    if (bridge.supports('openHotsoon')) {
        return new Promise((reslove, reject) => {
            bridge
                .call('openHotsoon', {
                    type: 'login_panel',
                    args: {
                        mobile_title: '请登录',
                        go_mobile: true,
                        with_weixin: true
                    }
                })
                .then((res: any) => {
                    if (res.code !== 1) reject(new Error('唤起登录失败'));
                })
                .catch((err) => {
                    reject(err);
                });
            bridge.listen('loginStatus', (res: any) => {
                if (Number(res.args.code) === 1) {
                    return reslove(res.args);
                }
                reject(res.args);
            });
        });
    }
    return Promise.reject(new Error('not supports'));
}
